import React from 'react'

export function TeamsLanding() {
  return (
    <div className="teams-landing-jumbo">

    </div>
  )
}
